import Base from '@studiometa/js-toolkit';
import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

/**
 * @typedef {Object} ReviewsRef
 * @property {HTMLElement} slider
 * @property {HTMLElement[]} prev[]
 * @property {HTMLElement[]} next[]
 * @property {HTMLElement} current
 */

/**
 * @typedef {Object} ReviewsInterface
 * @property {ReviewsRef} $refs
 */

/**
 * Homepage class.
 */
export default class Reviews extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'Reviews',
    refs: ['slider', 'prev[]', 'next[]', 'current'],
  };

  /**
   * Initialize the component's behavior.
   *
   * @this {Reviews & ReviewsInterface}
   */
  mounted() {
    this.slider = new Swiper(this.$refs.slider, {
      loop: true,
      loopAdditionalSlides: 1,
      slidesPerView: 1,
      grabCursor: true,
    });

    this.$refs.prev.forEach((prevEl) => {
      prevEl.addEventListener('click', () => {
        this.slider.slidePrev();
      });
    });

    this.$refs.next.forEach((nextEl) => {
      nextEl.addEventListener('click', () => {
        this.slider.slideNext();
      });
    });

    this.slider.on('slideChange', () => {
      this.$refs.current.innerHTML = (this.slider.realIndex + 1).toString();
    });
  }
}
